import { Directive, HostListener, ElementRef, Output, EventEmitter, Input, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class NgxNearbyDirective {
    /**
     * @param {?} elementRef
     */
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.nearby = new EventEmitter();
    }
    /**
     * @param {?} ev
     * @return {?}
     */
    mousemoveFn(ev) {
        requestAnimationFrame((/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            const mousePosition = this.getMousePos(ev);
            /** @type {?} */
            const documentScrolls = {
                left: document.body.scrollLeft + document.documentElement.scrollLeft,
                top: document.body.scrollTop + document.documentElement.scrollTop,
            };
            /** @type {?} */
            const elRect = this.elementRef.nativeElement.getBoundingClientRect();
            /** @type {?} */
            const elCoords = {
                x1: elRect.left + documentScrolls.left,
                x2: elRect.width + elRect.left + documentScrolls.left,
                y1: elRect.top + documentScrolls.top,
                y2: elRect.height + elRect.top + documentScrolls.top,
            };
            /** @type {?} */
            const closestPoint = { x: mousePosition.x, y: mousePosition.y };
            if (mousePosition.x < elCoords.x1) {
                closestPoint.x = elCoords.x1;
            }
            else if (mousePosition.x > elCoords.x2) {
                closestPoint.x = elCoords.x2;
            }
            if (mousePosition.y < elCoords.y1) {
                closestPoint.y = elCoords.y1;
            }
            else if (mousePosition.y > elCoords.y2) {
                closestPoint.y = elCoords.y2;
            }
            if (!this.nearby.isStopped) {
                /** @type {?} */
                const distance = this.distancePoints(mousePosition.x, mousePosition.y, closestPoint.x, closestPoint.y);
                if (this.nearbyActiveDistance !== undefined && this.nearbyActiveDistance >= distance) {
                    this.nearby.emit({ distance, nearby: true });
                }
                else if (this.nearbyActiveDistance !== undefined && this.nearbyActiveDistance < distance) {
                    this.nearby.emit({ distance, nearby: false });
                }
                else if (this.nearbyActiveDistance === undefined) {
                    this.nearby.emit(distance);
                }
            }
        }));
    }
    /**
     * @private
     * @param {?} x1
     * @param {?} y1
     * @param {?} x2
     * @param {?} y2
     * @return {?}
     */
    distancePoints(x1, y1, x2, y2) {
        return Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
    }
    /**
     * @private
     * @param {?} e
     * @return {?}
     */
    getMousePos(e) {
        /** @type {?} */
        let posX = 0;
        /** @type {?} */
        let posY = 0;
        if (e.pageX || e.pageY) {
            posX = e.pageX;
            posY = e.pageY;
        }
        else if (e.clientX || e.clientY) {
            posX = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
            posY = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
        }
        return { x: posX, y: posY };
    }
}
NgxNearbyDirective.ɵfac = function NgxNearbyDirective_Factory(t) { return new (t || NgxNearbyDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NgxNearbyDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: NgxNearbyDirective, selectors: [["", "ngxNearby", ""]], hostBindings: function NgxNearbyDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mousemove", function NgxNearbyDirective_mousemove_HostBindingHandler($event) { return ctx.mousemoveFn($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, inputs: { nearbyActiveDistance: "nearbyActiveDistance" }, outputs: { nearby: "nearby" } });
/** @nocollapse */
NgxNearbyDirective.ctorParameters = () => [
    { type: ElementRef }
];
NgxNearbyDirective.propDecorators = {
    nearbyActiveDistance: [{ type: Input }],
    nearby: [{ type: Output }],
    mousemoveFn: [{ type: HostListener, args: ['document:mousemove', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxNearbyDirective, [{
        type: Directive,
        args: [{
                selector: '[ngxNearby]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { nearby: [{
            type: Output
        }], 
    /**
     * @param {?} ev
     * @return {?}
     */
    mousemoveFn: [{
            type: HostListener,
            args: ['document:mousemove', ['$event']]
        }], nearbyActiveDistance: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxNearbyModule {
}
NgxNearbyModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgxNearbyModule });
NgxNearbyModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NgxNearbyModule_Factory(t) { return new (t || NgxNearbyModule)(); }, imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxNearbyModule, { declarations: [NgxNearbyDirective], exports: [NgxNearbyDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxNearbyModule, [{
        type: NgModule,
        args: [{
                declarations: [NgxNearbyDirective],
                imports: [],
                exports: [NgxNearbyDirective]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { NgxNearbyDirective, NgxNearbyModule };

//# sourceMappingURL=ngx-nearby.js.map